<template>
  <div>
    <agile-table
      :data-type="'resellers'"
      :data="resellers"
      :tableMeta="tableMeta"
      :filter-meta="filterMeta"
      :action-meta="actionMeta"
      :column-meta="columnMeta"
      @rowAction="rowAction"
      @fieldAction="fieldAction" />
    <new-button @clicked="openResellerModal" />
    <slideout-panel />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import AgileTable from '@/components/table/AgileTable'
import ResellerModal from '@/components/modals/ResellerModal'

export default {
  components: {
    NewButton,
    AgileTable,
    ResellerModal
  },
  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      tableMeta: {
        headingIcon: 'fa-chevrons-right'
      },

      filterMeta: [{
        fieldId: 'name',
        type: 'string',
        label: 'Återförsäljare'
      },
      {
        fieldId: 'organizationNumber',
        type: 'string',
        label: 'Organisationsnummer'
      }
      ],

      columnMeta: {
        hasActions: true,
        items: [
          {
            fieldId: 'name',
            label: 'Företag'
          },
          {
            fieldId: 'organizationNumber',
            label: 'Org. nr.'
          },
          {
            fieldId: 'customers',
            label: 'Kunder',
            dataType: 'callback',
            callback: (item) => {
              if (!item.customers || item.customers.length === 0) {
                return '-'
              }
              return item.customers.map(x => x.name).join(', ')
            }
          }
        ]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          label: 'Redigera',
          action: 'updateReseller',
          iconClass: 'fal fa-pen'
        },
        {
          label: 'Kunder',
          action: 'goToCustomersPage',
          iconClass: 'fal fa-building'
        },
        {
          label: null,
          action: 'deleteReseller',
          iconClass: 'fal fa-xmark',
          buttonClass: 'is-danger'
        }]
      }
    }
  },

  watch: {
    'resellers.filter': {
      handler () {
        this.$store.state.resellers.all.currentPage = 1
        this.getListData()
      },
      deep: true
    }
  },

  computed: {
    ...mapState({
      resellers: state => state.resellers.all
    })
  },

  methods: {
    ...mapActions('resellers', ['initialize', 'getListData', 'delete']),

    rowAction (action, reseller) {
      switch (action) {
        case 'updateReseller':
          this.openResellerModal(reseller.resellerId)
          break

        case 'deleteReseller':
          this.deleteReseller(reseller)
          break

        case 'goToCustomersPage':
          this.goToCustomersPage(reseller)
          break

        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    fieldAction (action, reseller) {
      switch (action) {
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    goToCustomersPage (reseller) {
      this.$router.push({ name: 'ResellerCustomers', params: { reseller: reseller, resellerId: parseInt(reseller.resellerId) } })
    },

    openResellerModal (resellerId) {
      this.$panel(ResellerModal, { resellerId })
    },

    deleteReseller (reseller) {
      if (reseller.customers && reseller.customers.length) {
        this.$alertOptions({ title: 'Kan inte ta bort återförsäljare', text: `${reseller.name} har kunder kopplade. Om du vill ta bort återförsäljaren får du ta bort kunderna först`, icon: 'error' })
        return
      }

      this.$confirm('Radera återförsäljare', 'Är du säker på att du vill radera återförsäljaren ' + reseller.name + '?').then((result) => {
        if (result.value) {
          this.delete(reseller.resellerId)
          this.getListData(1)
        }
      })
    }
  },

  created () {
    this.initialize()
    this.getListData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/Reseller/ResellersPage.vue